import { MessageDescriptor, useIntl } from "react-intl";

import { portalLabels as l } from "./labels";

export const TASK_STATUS = {
  OPEN: "open",
  DONE: "done",
  APPROVED: "approved",
  CANCELLED: "cancelled",
};

const STATUS: Record<string, MessageDescriptor> = {
  open: l.taskOpen,
  done: l.taskDone,
  approved: l.taskApproved,
  cancelled: l.taskCancelled,
  submitted: l.reportSubmitted,
  returned: l.reportReturned,
};

/** Task and daily report statuses in the UI language. */
export const useTaskStatusLabel = () => {
  const intl = useIntl();

  return (status: string) => (STATUS[status] ? intl.formatMessage(STATUS[status]) : status);
};
